"use strict";

exports.__esModule = true;
exports.CycleSplitterBody = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _CycleList = require("../CycleList");
var _ClassificationSelector = require("../ClassificationSelector/ClassificationSelector");
var _timeDefinitions = require("../../timeDefinitions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var CycleSplitterView = _styledComponents["default"].div.withConfig({
  displayName: "CycleSplitterBody__CycleSplitterView",
  componentId: "sc-kcpvo9-0"
})(["display:flex;flex-direction:column;width:100%;"]);
var CycleSplitterRow = _styledComponents["default"].div.withConfig({
  displayName: "CycleSplitterBody__CycleSplitterRow",
  componentId: "sc-kcpvo9-1"
})(["flex-grow:1;display:flex;justify-content:center;"]);
var DurationSlider = _styledComponents["default"].input.withConfig({
  displayName: "CycleSplitterBody__DurationSlider",
  componentId: "sc-kcpvo9-2"
})(["box-sizing:border-box;margin:2rem;"]);
var CycleSplitterPart = _styledComponents["default"].div.withConfig({
  displayName: "CycleSplitterBody__CycleSplitterPart",
  componentId: "sc-kcpvo9-3"
})(["display:flex;flex-grow:1;flex-direction:column;align-items:center;justify-content:start;"]);

/**
 * An interface that allows a user to split a cycle into two.
 */
var CycleSplitterBody = exports.CycleSplitterBody = /*#__PURE__*/function (_Component) {
  function CycleSplitterBody() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleSliderChange = function (e) {
      var splitAt = Number(e.target.value);
      var _this$props = _this.props,
        parts = _this$props.parts,
        onChange = _this$props.onChange;
      onChange([Object.assign({}, parts[0], {
        interval: {
          startMillis: parts[0].interval.startMillis,
          endMillis: splitAt
        }
      }), Object.assign({}, parts[1], {
        interval: {
          startMillis: splitAt,
          endMillis: parts[1].interval.endMillis
        }
      })]);
    };
    return _this;
  }
  _inheritsLoose(CycleSplitterBody, _Component);
  var _proto = CycleSplitterBody.prototype;
  _proto.createReclassifyHandler = function createReclassifyHandler(index) {
    var _this2 = this;
    return function (_ref) {
      var state = _ref.state,
        activity = _ref.activity;
      var onChange = _this2.props.onChange;
      var parts = [_this2.props.parts[0], _this2.props.parts[1]];
      var old = parts[index];
      parts[index] = Object.assign({}, old, {
        value: {
          state: state.id,
          activity: activity ? activity.id : undefined
        }
      });
      onChange(parts);
    };
  };
  _proto.isLastSplit = function isLastSplit(numberOfParts, index) {
    return numberOfParts - 1 === index;
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props2 = this.props,
      classification = _this$props2.classification,
      plantStateActivities = _this$props2.plantStateActivities,
      parts = _this$props2.parts,
      device = _this$props2.device;
    var allowProducing = device && device.allowProducing;
    return /*#__PURE__*/_react["default"].createElement(CycleSplitterView, null, /*#__PURE__*/_react["default"].createElement(CycleSplitterRow, null, /*#__PURE__*/_react["default"].createElement(_CycleList.CycleListItem, {
      classification: classification,
      plantStateActivities: plantStateActivities
    })), /*#__PURE__*/_react["default"].createElement(DurationSlider, {
      type: "range",
      min: classification.interval.startMillis + _timeDefinitions.SECOND_IN_MILLIS,
      max: classification.interval.endMillis - _timeDefinitions.SECOND_IN_MILLIS,
      value: parts[0].interval.endMillis,
      onChange: this.handleSliderChange
    }), /*#__PURE__*/_react["default"].createElement(CycleSplitterRow, null, parts.map(function (part, index) {
      return /*#__PURE__*/_react["default"].createElement(CycleSplitterPart, {
        key: index
      }, /*#__PURE__*/_react["default"].createElement(_CycleList.CycleListItem, {
        style: {
          width: 300
        },
        classification: part,
        plantStateActivities: plantStateActivities
      }), _this3.props.shouldNotClassifyLastSplit && _this3.isLastSplit(parts.length, index) ? null : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_ClassificationSelector.ClassificationSelector, {
        plantStateActivities: plantStateActivities,
        onChange: _this3.createReclassifyHandler(index),
        activityPredicate: function activityPredicate(state) {
          if (state.id === "producing" && !allowProducing) {
            return false;
          }
          return true;
        },
        "data-testid": "CycleSplitterBody.classification.selector"
      }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "change-activity",
        defaultMessage: "Change Activity"
      }))));
    })));
  };
  return CycleSplitterBody;
}(_react.Component);